import { User } from "@core/types";
import { customerSurveyClient } from "@core/clients";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { SupaCustomerSurveyCompletionsType } from "../../4time/src/shared/types/supabaseFragments";

type Options = UseQueryOptions<
  SupaCustomerSurveyCompletionsType | null,
  unknown,
  SupaCustomerSurveyCompletionsType | null,
  string[]
>;

const useGetCustomerSurveyAnswers = (userPhone: User["phone"], options?: Options) => {
  return useQuery(
    ["customer-survey/get"],
    async () => {
      if (!userPhone) {
        throw new Error("userPhone is required for getCustomerSurveyAnswers fn");
      }

      if (customerSurveyClient) {
        return customerSurveyClient.getCustomerSurveyAnswers(userPhone);
      }

      throw new Error("customerSurveyClient not implemented");
    },
    {
      cacheTime: CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS,
      staleTime: CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetCustomerSurveyAnswers;
